import React, { useCallback, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { Card, CardBody, Col, Row } from "reactstrap"
import totalOrdersImg from "assets/images/cards/dashboard/totalOrders.png"
import earningsImg from "assets/images/cards/dashboard/earnings.png"
import lowStockAlertImg from "assets/images/cards/dashboard/lowStockAlert.png"
import pendingOrdersImg from "assets/images/cards/dashboard/pendingOrders.png"
import revenueImg from "assets/images/cards/dashboard/revenue.png"
import { useNavigate } from "react-router-dom"
import { CurrentTapType as OrderCurrentTapType } from "pages/vendor/Orders/ordersType"

export const OverviewCards = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const cardsData: {
    title: string
    total: number | string
    img: string
    currency?: string
  }[] = useMemo(() => {
    return [
      {
        title: t("dashboard_totalOrders"),
        total: 200,
        img: totalOrdersImg,
      },
      {
        title: t("dashboard_pendingOrders"),
        total: 8,
        img: pendingOrdersImg,
      },
      {
        title: t("dashboard_revenue"),
        total: 25_000,
        currency: t("common_qar") as string,
        img: revenueImg,
      },
      {
        title: t("dashboard_earnings"),
        total: 21_230,
        currency: t("common_qar") as string,
        img: earningsImg,
      },
      {
        title: t("dashboard_lowStockAlert"),
        total: 3,
        img: lowStockAlertImg,
      },
    ]
  }, [t])

  const cardClickHandler = useCallback(
    (index: number) => {
      switch (index) {
        case 0:
          navigate("/orders?tab=" + OrderCurrentTapType.all)
          break
        case 1:
          navigate("/orders?tab=" + OrderCurrentTapType.pending)
          break
        case 2:
        case 3:
          navigate("/revenue")
          break
        case 4:
          navigate("/products?lowStockAlert=" + cardsData[index].total)
          break
        default:
          break
      }
    },
    [navigate]
  )

  return (
    <Row style={{ marginBottom: "-1.5rem" }}>
      {cardsData.map((report, key) => (
        <Col
          md="4"
          lg="2.4"
          key={"_col_" + key}
          className="col-lg-5ths"
          style={{ height: "fit-content" }}
        >
          <Card
            className="mini-stats-wid shadow-md rounded-3"
            style={{ cursor: "pointer" }}
            onClick={() => cardClickHandler(key)}
          >
            <CardBody>
              <div className="d-flex">
                <div className="flex-grow-1">
                  <p className="text-muted fw-medium text-capitalize">
                    {report.title}
                  </p>
                  <div className="d-flex gap-1 align-items-baseline justify-content-start">
                    {report.currency && (
                      <h6 className="mb-0">{report.currency}</h6>
                    )}
                    <h4 className="mb-0">{report.total.toLocaleString()}</h4>
                  </div>
                </div>
                <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                  <span className="avatar-title rounded-circle bg-primary">
                    <img
                      src={report.img}
                      alt={report.title}
                      className="img-fluid"
                    />
                  </span>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  )
}
